module.exports = __webpack_public_path__ + "static/media/wrapper-title.c172ffcf.png";